import { motion } from 'framer-motion';
import { Footer } from '../components/Footer';

export function TermsPage() {
  return (
    <div className="min-h-screen bg-dark-bg">
      <section className="pt-40 pb-20 px-4">
        <div className="max-w-2xl mx-auto">
          <motion.h1
            className="font-heading font-bold text-3xl mb-6"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
          >
            Terms of Service
          </motion.h1>
          <p className="text-content-secondary font-body leading-relaxed">
            Our terms of service are being finalised and will be published before CogniPrint's public launch. For questions, contact{' '}
            <a href="mailto:legal@cogniprint.io" className="text-indigo-400 hover:text-indigo-300 transition-colors">
              legal@cogniprint.io
            </a>
            .
          </p>
        </div>
      </section>
      <Footer />
    </div>
  );
}
